import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import classNames from 'classnames';
import styles from 'wienenergiedesignsystem/components/Link/Link.module.scss';
var Link = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var to = _ref.to,
      children = _ref.children,
      className = _ref.className,
      other = _objectWithoutPropertiesLoose(_ref, ["to", "children", "className"]);

  return /*#__PURE__*/React.createElement("a", Object.assign({
    ref: ref,
    href: to,
    className: classNames(styles.link, className)
  }, other), children);
});
export default Link;